"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useCheckIsSubheaderCell = function (rowIndex, fixedRowCount) { return !!(fixedRowCount > 1 && rowIndex === 1); };
exports.default = useCheckIsSubheaderCell;
